import { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Button, Notification } from '@components/shared';
import { useDispatch } from 'react-redux';
import api from '@shared/api';
import routes from '@root/routes';
import actions from '@store/actions/saved';
import searchPageActions from '@store/actions/listingSearchPage/analyticsActions';
import { ListingSearchCriteria } from '@components/layouts/Truva/ListingSearchDeprecated/utils';
import s from './SaveSearch.module.less';

type Props = {
  criteria: ListingSearchCriteria;
};

const SaveSearch = ({ criteria }: Props) => {
  const { t } = useTranslation('filters');

  const dispatch = useDispatch();
  const [searchSaved, setSearchSaved] = useState(false);
  const savedSearchLinkClicked = () => {
    dispatch(searchPageActions.savedSearchNotificationLinkClicked());
  };

  useEffect(() => {
    setSearchSaved(false);
  }, [criteria]);

  const saveTheCurrentSearch = async () => {
    if (searchSaved) return;
    const response = await api.post(routes.api.savedSearches, criteria.toSavedSearchParameters());
    if (response.ok) {
      dispatch(actions.savedASearch());
      Notification.saveSuccess({
        title: t('saveSearch:saved'),
        placement: 'bottomLeft',
        duration: 3.5,
        /* eslint-disable react/jsx-no-literals */
        text: (
          <Trans i18nKey="viewInFavorites" ns="saveSearch">
            You’ll get notified when a listing matches your search. View or edit it in your
            <a href={routes.savedSearches} onClick={savedSearchLinkClicked}>
              saved searches.
            </a>
          </Trans>
        ),
        /* eslint-disable react/jsx-no-literals */
      });
      setSearchSaved(true);
    }
  };

  return (
    <Button
      onClick={saveTheCurrentSearch}
      className={s.button}
      type="secondary"
      size="medium"
      disabled={!criteria.isSaveable()}
      icon={searchSaved ? 'heart' : 'heart-outline'}
    >
      {searchSaved ? t('saveSearch:savedTitle') : t('saveSearch:unsavedTitle')}
    </Button>
  );
};

export default SaveSearch;
